import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { HTTP_URL_REGEXP, EMAIL_REGEXP } from '@lib/common/constants';

@Component({
  selector: 'sn-text-transformer',
  templateUrl: './text-transformer.component.html',
  styleUrls: ['./text-transformer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnTextTransformerComponent {
  @Input()
  get text(): string {
    return this._text;
  }
  set text(value: string) {
    this._text = value;
    this.type = this._getTextType(value);
  }

  public type: string;

  private _text: string;

  constructor() {}

  private _getTextType(value: string): string {
    if (HTTP_URL_REGEXP.test(value)) {
      return 'link';
    }

    if (EMAIL_REGEXP.test(value)) {
      return 'email';
    }

    return 'text';
  }
}
